<p>{{ 'gwirio.ffurflenteitlrhandisgrifiad' | translate }}</p>

<mat-card appearance="outlined" class="container-ffurflen">

  <div fxLayout.xs="column">
    <span class="eitem-marcio">
      <fa-icon icon="check-circle"></fa-icon> {{ 'gwirio.dimdiffyg' | translate }}
    </span>
    <span class="eitem-marcio">
      <fa-icon icon="times-circle"></fa-icon> {{ 'gwirio.gydadiffyg' | translate }}
    </span>
    <span class="eitem-marcio"><strong>N/A</strong> {{ 'gwirio.ddimyngymwys' | translate }}</span>
  </div>

</mat-card>

<mat-accordion>
  @for (field of field.fieldGroup; track field; let i = $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="teitl-panel">
          <b>{{ model[i].teitl | translate | uppercase }}</b>
        </mat-panel-title>
        <!-- <mat-panel-description class="gweithred-panel">
        {{ model[i].gweithred | translate }}
      </mat-panel-description> -->
    </mat-expansion-panel-header>
    <div class="container-gweithred">
      <fa-icon icon="info-circle"></fa-icon> {{ model[i].gweithred | translate }}
    </div>
    <formly-group [field]="field"></formly-group>
  </mat-expansion-panel>
}
</mat-accordion>